import Button from "../../UI/Button";

export interface AccordionProps {
  id: number;
  name: string;
  isButtonLoading: boolean;
  description: string;
  icon: JSX.Element;
  isUsed: boolean;
  onSubmit: (id: number, status: boolean) => void;
}

const DashboardWidgetList = (props: AccordionProps) => {
  const { id, name, icon, isButtonLoading, description, isUsed, onSubmit } =
    props;

  return (
    <div className="py-5 border-b-2 border-slate-200">
      <div className="flex justify-between items-center pb-2">
        <div className="flex justify-between gap-3 text-neutralColor-light">
          {icon}
          <h5 className="font-bold text-sm text-neutralColor-medium">{name}</h5>
        </div>
      </div>
      <div className="pl-8 pb-2">
        <small className="text-xs text-gray-500">{description}</small>
      </div>
      <div className="pl-8">
        {isUsed ? (
          <Button
            label="Remove"
            type="button"
            btnStyle="btn-tertiary"
            btnSize="btn-sm"
            disabled={isButtonLoading}
            onClick={() => onSubmit(id, isUsed)}
          />
        ) : (
          <Button
            label="Add"
            type="button"
            btnStyle="btn-primary"
            btnSize="btn-sm"
            disabled={isButtonLoading}
            onClick={() => onSubmit(id, isUsed)}
          />
        )}
      </div>
    </div>
  );
};

export default DashboardWidgetList;
